export default {
  isLoadingTotp: false,
  totp: null,
  validationErrorMessage: '',
  enable2faLoading: false,
};
